import CabifyImg from '../../../Assets/Cards/cabifyImg.png';
import HudlImg from '../../../Assets/Cards/hudlImg.png';
import ModeImg from '../../../Assets/Cards/modeImg.png';
import BuzzImg from '../../../Assets/Cards/buzzImg.png';

import cabifyLogo from '../../../Assets/Cards/cabify.svg';
import hudlLogo from '../../../Assets/Cards/hudl.svg';
import modeLogo from '../../../Assets/Cards/mode.svg';
import buzzLogo from '../../../Assets/Cards/buzz.svg';

export const numberList =[
    {
        number:3000,
        title:"Artboards",
        desc:"Hostdesign is compatible with Sketch and supported the team's big projects"
    },
    {
        number:"100+",
        title:"Prototypes",
        desc:"Hostdesign enables the team to scale and supports high volumes of projects"
    },
    {
        number:2,
        title:"Weeks to Ship",
        desc:"Prototyping with Hostdesign allows the team to accelerate their entire design process"
    }
]

export const cardsData = [
    {
        Image:CabifyImg,
        logo:cabifyLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#9870FF"
    },
    {
        Image:HudlImg,
        logo:hudlLogo,
        desc:"How Hudl drive great UX through daily user testing with Hostdesign",
        color:"#F2541B"
    },
    ,{
        Image:ModeImg,
        logo:modeLogo,
        desc:"How Cabify closed design feedback loops to 15 minutes with HostDesign",
        color:"#03B384"
    },
    {
        Image:BuzzImg,
        logo:buzzLogo,
        desc:"How Buzzfeed's design team created a single source of truth with Hostdesign",
        color:"#FF4F5A"
    },
]

export const sectionsData1 = [
    {
        desc:'“Speed is incredibly important for us,” says Hugo Conejo, Monzo’s head of design. Looking at the bank’s history, it’s not difficult to see why. Launched in late 2015 by a group of five friends, the bank that lives in your smartphone, set the record for quickest crowd-funding campaign in history in 2016 - raising £1m in 96 seconds via the Crowdcube investment platform. '
    },
    {
        desc:"A little over a year later, in May 2017, the company announced more than £250 million had been spent through its prepaid card, thanks to its 200,000 customers. Today that figure is more than half a million users and more than £800 million spent."
    },
    {
        desc:"To be able to grow and scale at that pace requires design and development tools that teams can work on quickly and simply without bottle necks. That’s where Marvel comes in."
    }
]

export const sectionsData2 = [
    {
        title:"Rapid iteration",
        desc:"One of the initial tasks Hugo had in developing Monzo’s workflow was how to allow multiple teams to give feedback and input at key moments without disrupting the design team’s workload."
    },
    {
        desc:"“In the beginning, someone would spot a mistake. Instead of someone fixing it in the design, they would go to the developer and send it in code, but the design would still be outdated.”"
    }
]
export const sectionsData3 = [
    {
        desc:"That created a bottleneck that would then have to be unpicked by designers and developers, slowing down the rapid iteration the company is used to. So they turned to Marvel. Hugo and his team started by designing the features Monzo’s customer support would use to answer queries. “We loved how it worked so much, we rolled out Marvel across all of our projects and platforms.” "
    },
    {
        desc:"Today, Monzo has hundreds of designs running concurrently through Marvel’s platform. One of the key benefits of transferring the company’s numerous projects onto Marvel is the transparency it creates between teams: a place where if someone makes changes, everyone can see those changes. Instead of trawling through email chains and Slack threads, Hugo and his team can see what everyone is working on at any one time."
    },
    {
        title:"Working at scale",
        desc:"Hugo found other tools on the market tended to break or freeze when working at the scale he and his team do. With more than 100 prototypes, and nearly 200 projects in development at once, Marvel has kept up with the pace."
    },
    {
        desc:"Another key feature Hugo likes about Marvel is how seamless it fits into Monzo’s workflow."
    }
]